/** Fired after catalog writes so open shop tabs can refresh. */
export const CATALOG_UPDATED_EVENT = 'saloni-catalog-updated';

/**
 * detail.origin for silent admin auto-saves.
 * Admin skips self-refetch; shop routes still reload.
 */
export const CATALOG_UPDATED_SILENT_ORIGIN = 'admin-persist-silent';
